"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ETextBadgeTextType;

(function (ETextBadgeTextType) {
  ETextBadgeTextType[ETextBadgeTextType["WIN"] = 0] = "WIN";
  ETextBadgeTextType[ETextBadgeTextType["LOSE"] = 1] = "LOSE";
  ETextBadgeTextType[ETextBadgeTextType["START"] = 2] = "START";
  ETextBadgeTextType[ETextBadgeTextType["FAILED"] = 3] = "FAILED";
  ETextBadgeTextType[ETextBadgeTextType["VICTORY"] = 4] = "VICTORY";
  ETextBadgeTextType[ETextBadgeTextType["STAGE_N_START"] = 5] = "STAGE_N_START";
  ETextBadgeTextType[ETextBadgeTextType["LAST_STAGE_START"] = 6] = "LAST_STAGE_START";
  ETextBadgeTextType[ETextBadgeTextType["STAGE_N_SUCCESS"] = 7] = "STAGE_N_SUCCESS";
  ETextBadgeTextType[ETextBadgeTextType["LAST_STAGE_SUCCESS"] = 8] = "LAST_STAGE_SUCCESS";
  ETextBadgeTextType[ETextBadgeTextType["STAGE_N_FAIL"] = 9] = "STAGE_N_FAIL";
  ETextBadgeTextType[ETextBadgeTextType["LAST_STAGE_FAIL"] = 10] = "LAST_STAGE_FAIL";
})(ETextBadgeTextType || (ETextBadgeTextType = {}));

var _default = ETextBadgeTextType;
exports.default = _default;